/* The mobile filter toggle: a real button that says whether the rail is open (aria-expanded) and moves with the keyboard.
   It replaced a hidden checkbox and a label, which a keyboard or a screen reader could not reach (OPS audit H7). Below 64rem
   the rail starts closed; above it the button is not drawn and the rail is always open. */
(function () {
  const layout = document.querySelector('[data-djh-filter-layout]');
  const toggle = document.querySelector('[data-djh-filter-toggle]');
  if (!layout || !toggle) return;
  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) layout.setAttribute('data-filters-open', '');
    else layout.removeAttribute('data-filters-open');
  });
})();
